var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstrupontes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M423.724,164.31H88.276c-4.873,0-8.828-3.946-8.828-8.828c0-4.882,3.955-8.828,8.828-8.828h335.448 c4.873,0,8.828,3.946,8.828,8.828C432.552,160.364,428.597,164.31,423.724,164.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M123.586,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v88.276C132.414,248.64,128.459,252.586,123.586,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M167.724,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v88.276C176.552,248.64,172.597,252.586,167.724,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M211.862,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828v88.276C220.69,248.64,216.735,252.586,211.862,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M256,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v88.276C264.828,248.64,260.873,252.586,256,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M300.138,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828v88.276C308.966,248.64,305.011,252.586,300.138,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M344.276,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828v88.276C353.103,248.64,349.149,252.586,344.276,252.586"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M388.414,252.586c-4.873,0-8.828-3.946-8.828-8.828v-88.276c0-4.882,3.955-8.828,8.828-8.828 s8.828,3.946,8.828,8.828v88.276C397.241,248.64,393.287,252.586,388.414,252.586"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDC3C7"
    },
    points: "17.655,243.756 70.621,243.756 70.621,173.135 17.655,173.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDC3C7"
    },
    points: "70.621,137.828 17.655,137.828 35.31,67.207 52.966,67.207  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8C8D"
    },
    points: "0,173.135 88.276,173.135 88.276,137.825 0,137.825  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8C8D"
    },
    d: "M70.621,40.724c0,14.627-11.855,26.483-26.483,26.483S17.655,55.351,17.655,40.724 s11.855-26.483,26.483-26.483S70.621,26.097,70.621,40.724"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDC3C7"
    },
    points: "441.379,243.756 494.345,243.756 494.345,173.135 441.379,173.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDC3C7"
    },
    points: "494.345,137.828 441.379,137.828 459.034,67.207 476.69,67.207  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8C8D"
    },
    points: "423.724,173.135 512,173.135 512,137.825 423.724,137.825  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8C8D"
    },
    d: "M494.345,40.724c0,14.627-11.855,26.483-26.483,26.483s-26.483-11.855-26.483-26.483 s11.855-26.483,26.483-26.483S494.345,26.097,494.345,40.724"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D39E5F"
    },
    points: "0,279.066 512,279.066 512,243.756 0,243.756  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC176"
    },
    d: "M105.93,499.759H17.654v-220.69h476.69v220.69h-88.276c0-82.944-67.116-150.069-150.069-150.069 C173.055,349.69,105.93,416.815,105.93,499.759"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4482C3"
    },
    d: "M176.552,490.931c-14.601,0-26.483-11.882-26.483-26.483c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828c0,4.873,3.964,8.828,8.828,8.828c4.864,0,8.828-3.955,8.828-8.828 c0-4.882,3.955-8.828,8.828-8.828s8.828,3.946,8.828,8.828C203.034,479.049,191.153,490.931,176.552,490.931"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4482C3"
    },
    d: "M335.448,490.931c-14.601,0-26.483-11.882-26.483-26.483c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828c0,4.873,3.964,8.828,8.828,8.828s8.828-3.955,8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828C361.931,479.049,350.049,490.931,335.448,490.931"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4482C3"
    },
    d: "M256,446.793c-14.601,0-26.483-11.882-26.483-26.483c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828c0,4.873,3.964,8.828,8.828,8.828s8.828-3.955,8.828-8.828c0-4.882,3.955-8.828,8.828-8.828 c4.873,0,8.828,3.946,8.828,8.828C282.483,434.911,270.601,446.793,256,446.793"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39E5F"
    },
    d: "M450.207,340.862c-4.873,0-8.828,3.946-8.828,8.828c0,4.882,3.955,8.828,8.828,8.828h44.138 v-17.655H450.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39E5F"
    },
    d: "M423.724,393.828c-4.873,0-8.828,3.946-8.828,8.828c0,4.882,3.955,8.828,8.828,8.828h70.621 v-17.655H423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39E5F"
    },
    d: "M61.793,358.517c4.873,0,8.828-3.946,8.828-8.828c0-4.882-3.955-8.828-8.828-8.828H17.655v17.655 H61.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39E5F"
    },
    d: "M88.276,411.483c4.873,0,8.828-3.946,8.828-8.828c0-4.882-3.955-8.828-8.828-8.828H17.655v17.655 H88.276z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstrupontes);
export default __webpack_public_path__ + "static/media/construpontes.148bc2e2d103649689a89306c1da223b.svg";
export { ForwardRef as ReactComponent };